import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';

import { CaretUpIcon } from '~components/icons';
import { CaretDownIcon } from '~components/icons/CaretDownIcon';
import { MyFilesDetailController } from '~extension/web2print/controller/MyFilesDetailController';
import { JobDownloadFormat } from '~extension/web2print/model/Job';

type DownloadFormatListItemProps = {
  jobId: number;
  documentId: number;
  clientId: number;
  downloadFormat: JobDownloadFormat;
  documentName: string;
};

export function DownloadFormatListItem({
  jobId,
  documentId,
  clientId,
  downloadFormat,
  documentName,
}: DownloadFormatListItemProps) {
  return (
    <Disclosure as="div">
      {({ open }) => (
        <>
          <DisclosureButton
            className={`appearance-none flex w-full justify-between items-center border-none outline-none text-left rounded-md transition shadow-none hover:shadow-md cursor-pointer ${
              open ? 'bg-gray' : 'bg-white hover:bg-gray'
            }`}
          >
            <span className="flex flex-col p-2">
              <span className="font-sans font-bold text-base">{downloadFormat.name}</span>
              <span className="font-sans text-sm">{downloadFormat.description}</span>
            </span>
            <div className="w-8 h-8 p-1">{open ? <CaretUpIcon /> : <CaretDownIcon />}</div>
          </DisclosureButton>
          <DisclosurePanel className="px-4 py-2">
            <MyFilesDetailController
              jobId={jobId}
              documentId={documentId}
              clientId={clientId}
              downloadFormat={downloadFormat}
              documentName={documentName}
            />
          </DisclosurePanel>
        </>
      )}
    </Disclosure>
  );
}
